const LAUNCHER_ENDPOINT = {
  NEW_LAUNCH: (brandId: string): string => `/brands/${brandId}/launcher`,
  LAUNCHER: (brandId: string, launchId: string): string =>
    `/brands/${brandId}/launcher/${launchId}`
};

export default LAUNCHER_ENDPOINT;
